import React, { useMemo } from 'react';
import clsx from 'clsx';
import TabsView from 'UI/components/templates/TabsView';

import { useStyles } from './DetailsTabs.styled';

const EMPTY_TAB_IDS = [];

export const DetailsTabs = ({
  initialTab,
  tabPanelPaddingExcludedIds = EMPTY_TAB_IDS,
  tabs = []
}) => {
  const classes = useStyles();
  const tabsWithPanelProps = useMemo(
    () =>
      tabs.map(tab => {
        if (tabPanelPaddingExcludedIds.includes(tab.id)) return tab;

        return {
          ...tab,
          tabPanelProps: {
            ...tab.tabPanelProps,
            className: clsx(classes.tabPanel, tab.tabPanelProps?.className)
          }
        };
      }),
    [classes.tabPanel, tabPanelPaddingExcludedIds, tabs]
  );

  return (
    <TabsView
      enableUrlNavigation={false}
      initialTab={initialTab}
      panelHeight="unset"
      tabs={tabsWithPanelProps}
      useIndexes={false}
    />
  );
};
